import React from "react";
import {
  Show,
  TextField,
  // EditButton,
  // RichTextField,
  BooleanField,
  NumberField,
  TabbedShowLayout,
  Tab,
} from "react-admin";
import { useAvailableCurrencies } from "../useAvailableCurrencies";
import CopyTemplateButton from "./CopyTemplateButton";
import ShowProductImages from "./ShowProductImages";
import PostNameListButton from "./PostNameListButton";
import { useProfile } from "../DataHooks/useProfile";
import CustomChipArrayField from "../CustomChipArrayField";
import CustomDateField from "../Common/CustomDateField";
import TieredPricesField from "./TieredPricesField";
import UserActionByResource from "../History/UserActionByResource";
import { useIsSeller } from "../DataHooks/user";

const KeywordShow = (props) => {
  const { profile } = useProfile();
  const { isMultiCurrency } = useAvailableCurrencies();
  const isSeller = useIsSeller();

  return (
    <Show title="Show keyword" {...props}>
      <TabbedShowLayout>
        <Tab label="Details">
          <TextField source="description" />
          <TextField source="key" />
          <TextField source="sku" label="SKU" />
          {isMultiCurrency && (
            <TextField source="currencyCode" label="Currency" />
          )}
          <NumberField source="price" />
          <TieredPricesField
            source="tieredPrices"
            label="Tiered Prices (Automatically applied during manual order item addition)"
          />
          <NumberField source="webPrice" />
          <TieredPricesField
            source="webTieredPrices"
            label="Webstore Tiered Price"
          />
          <NumberField source="stock" />
          <NumberField source="stockLeft" />
          <NumberField source="weight" label="Weight(Kg)" />
          <NumberField source="vipTier" />
          {isSeller && <NumberField source="cost" />}
          <NumberField source="minQuantity" />
          <NumberField
            source="maxQuantity"
            label="Max quantity(default 12H limitation)"
          />
          <TextField source="detail" />
          <CustomDateField source="createdAt" showTime />
          <CustomDateField source="updatedAt" showTime />
          <BooleanField source="isActive" />
          <BooleanField source="allowBackorder" />
          <BooleanField source="allowInWeb" />
          <CustomChipArrayField source="categories" label="Categories" />
          <CustomChipArrayField source="variants" label="Variants" />
          <CopyTemplateButton />
          {profile && <PostNameListButton />}
          <ShowProductImages />
        </Tab>
        <Tab label="History">
          <UserActionByResource />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default KeywordShow;
